(() => {
  const ready = () => {
    const panel = document.querySelector('[data-heir-pdp-ux]');
    if (!panel) return;
    const dimensions = panel.querySelector('[data-heir-selected-dimensions]');
    const availability = panel.querySelector('[data-heir-availability]');
    const sku = document.getElementById('current-variant-sku');
    const status = panel.querySelector('[data-heir-roomvo-status]');
    const price = panel.querySelector('[data-heir-current-price]');
    const roomvoButtons = [...panel.querySelectorAll('[data-heir-roomvo-jump]')];
    const fitToggle = panel.querySelector('[data-heir-fit-toggle]');
    const fitForm = panel.querySelector('[data-heir-fit-form]');
    let prices = {};
    try { prices = JSON.parse(panel.querySelector('[data-heir-pdp-price-map]')?.textContent || '{}'); } catch (_) {}
    const applyVariant = (variant) => {
      if (!variant) return;
      if (sku) sku.textContent = variant.sku || '—';
      if (dimensions) dimensions.textContent = variant.public_title || variant.title || 'Selected option';
      if (availability) availability.textContent = variant.available ? 'Available' : 'Sold out';
      const variantId = String(variant.id || '').split('/').pop();
      if (price && prices[variantId]) price.textContent = prices[variantId];
    };
    const applyVariantEvent = (event) => applyVariant(event.detail && event.detail.variant);
    document.addEventListener('product:variant-change', applyVariantEvent);
    document.addEventListener('variant:changed', applyVariantEvent);
    const roomvoContainer = () => document.querySelector('.roomvo-lite-container');
    const syncRoomvo = () => {
      const supported = Boolean(roomvoContainer());
      roomvoButtons.forEach((button) => { button.hidden = !supported; });
      return supported;
    };
    syncRoomvo();
    new MutationObserver(syncRoomvo).observe(document.documentElement, { childList: true, subtree: true });
    roomvoButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const visualizer = roomvoContainer();
        if (visualizer) {
          visualizer.id = 'roomvo-visualizer';
          visualizer.tabIndex = -1;
          const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          visualizer.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
          visualizer.focus({ preventScroll: true });
          if (status) status.textContent = 'Room visualizer opened below.';
        } else {
          button.hidden = true;
          if (status) status.textContent = 'Room preview is not available for this item.';
        }
      });
    });
    if (fitToggle && fitForm) {
      fitToggle.hidden = false;
      fitToggle.setAttribute('aria-expanded', String(!fitForm.hidden));
      const setFitOpen = (open) => {
        fitForm.hidden = !open;
        fitToggle.setAttribute('aria-expanded', String(open));
        if (open) {
          requestAnimationFrame(() => {
            if (!fitForm.hidden) fitForm.querySelector('input:not([type="hidden"]),textarea,select')?.focus();
          });
        } else {
          fitToggle.focus();
        }
      };
      fitToggle.addEventListener('click', () => setFitOpen(fitForm.hidden));
      const closeFitOnEscape = (event) => {
        if (event.key !== 'Escape' || fitForm.hidden) return;
        event.preventDefault();
        event.stopPropagation();
        setFitOpen(false);
      };
      fitForm.addEventListener('keydown', closeFitOnEscape);
      fitToggle.addEventListener('keydown', closeFitOnEscape);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})();
